var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useCallback, useState, createRef } from "react";
import Web3 from "web3";
import { QubicConnector } from "@qubic-js/react";
import { Web3ReactProvider, useWeb3React } from "@web3-react/core";
import qs from "query-string";
import ReactGA from "react-ga4";
import { InjectedConnector } from "@web3-react/injected-connector";
import dialogPolyfill from "dialog-polyfill";
import ActiveSpinner from "@/components/ActiveSpinner";
import { QUBIC_API_KEY, QUBIC_API_SECRET } from "../../constants/variable";
import InlineDownloadButtons from "../InlineDownloadButtons/InlineDownloadButtons";
import { CLIENT, GA_TRACKING_ID } from "../../constants";
import PolygonTop from "../../assets/img_polygon_top.png";
import PolygonDown from "../../assets/img_polygon_down.png";
import FacebookFill from "../../assets/ic_facebook_fill.svg";
import InstagramFill from "../../assets/ic_instagram_fill.svg";
import CheckFill from "../../assets/ic_check_circle_green_fill.svg";
import QubicLogin from "../../assets/qubic-login.svg";
import MetamaskFox from "../../assets/metamask-fox.svg";
import "./App.sass";
import { SUPPORTED_CHAIN_IDS } from "../../constants/blockchain";
import LogoQubic from '../../assets/logo-qubic.svg';
import LogoBlocktrend from '../../assets/logo-blocktrend.svg';
import VideoPomeloHat from '../../assets/video-pomelo-hat2.mp4';
var qubicConnector = new QubicConnector({
    apiKey: QUBIC_API_KEY || "b5a6bfea-553c-4640-8494-e14e8b2ae155",
    apiSecret: QUBIC_API_SECRET || "WfVkkGUsdCHHFDjCBAjNKNMoTqFSOLiF",
    chainId: 1,
    infuraProjectId: "",
    // optional, default: false, when value is true, the popup will hide automatically
    autoHideWelcome: false,
    // optional, default: false, when value is true, the show iframe instead of new window, credit card payment will failed with this option value true
    enableIframe: false,
});
var App = function () {
    useEffect(function () {
        ReactGA.initialize([
            {
                trackingId: GA_TRACKING_ID,
            },
        ]);
        ReactGA.send("pageview");
    }, []);
    var context = useWeb3React();
    var account = context.account, activate = context.activate;
    var _a = qs.parse(window.location.search), _b = _a.client, client = _b === void 0 ? CLIENT : _b, _c = _a.tag, tag = _c === void 0 ? "" : _c;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), done = _e[0], setDone = _e[1];
    var dialogRef = createRef();
    useEffect(function () {
        if (done || !account)
            return;
        fetch(qs.stringifyUrl({
            url: "https://script.google.com/macros/s/AKfycbzqZLQGvmSpufM8PWHEgfD2QIjlUZU-4NkoB7oCJpuuBhVsRMUE-V_p-MLoQkk8d_GTKA/exec",
            query: {
                client: client,
                tag: tag,
                address: account,
            },
        }))
            .then(function (res) { return res.json(); })
            .then(function (result) {
            var status = result.status;
            if (status === "success") {
                setLoading(false);
                setDone(true);
            }
        });
    }, [done, account, client, tag]);
    useEffect(function () {
        if (dialogRef.current) {
            dialogPolyfill.registerDialog(dialogRef.current);
        }
    }, [dialogRef]);
    var handleDesktopSignIn = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (dialogRef.current) {
                // @ts-ignore
                dialogRef.current.showModal();
            }
            return [2 /*return*/];
        });
    }); }, [dialogRef]);
    var handleQubicLoginIn = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dialogRef.current) {
                        // @ts-ignore
                        dialogRef.current.close();
                    }
                    setLoading(true);
                    return [4 /*yield*/, activate(qubicConnector, function (e) {
                            console.error("Qubic Wallet login ERROR", e);
                            alert("請登入 Qubic Wallet 以繼續進行登記");
                            setLoading(false);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [activate, dialogRef]);
    var handleLoginMetaMask = useCallback(function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var dappConnector;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ev === null || ev === void 0 ? void 0 : ev.preventDefault();
                    if (!window.ethereum ||
                        (window.ethereum && !window.ethereum.isMetaMask)) {
                        alert("請安裝 MetaMask extension 或者在 MetaMask App 內的 browser 打開。");
                        return [2 /*return*/];
                    }
                    if (dialogRef.current) {
                        // @ts-ignore
                        dialogRef.current.close();
                    }
                    setLoading(true);
                    dappConnector = new InjectedConnector({
                        supportedChainIds: SUPPORTED_CHAIN_IDS,
                    });
                    if (!(dappConnector && typeof window !== "undefined")) return [3 /*break*/, 2];
                    return [4 /*yield*/, activate(dappConnector, function (e) {
                            console.error("Metamask login ERROR", e);
                            alert("請登入 Metamask 以繼續進行登記");
                            setLoading(false);
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [activate, dialogRef]);
    var handleMobileSignIn = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window.ethereum && window.ethereum.isMetaMask) {
                        handleLoginMetaMask();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, activate(qubicConnector, function (e) {
                            console.error(e);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [activate, handleLoginMetaMask]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "App" }, { children: [_jsxs("header", { children: [_jsx("img", { src: LogoBlocktrend, alt: "Blocktrend" }, void 0), _jsx("div", __assign({ className: "cross" }, { children: "x" }), void 0), _jsx("img", { src: LogoQubic, alt: "Qubic" }, void 0)] }, void 0), _jsx("main", { children: _jsxs("div", __assign({ className: "content" }, { children: [_jsx("div", { children: _jsxs("section", __assign({ className: "asset" }, { children: [_jsx("div", __assign({ className: "left-bg" }, { children: _jsx("img", { src: PolygonTop, alt: "Left Bg" }, void 0) }), void 0), _jsx("div", __assign({ className: "card" }, { children: _jsxs("div", __assign({ className: "media-mask" }, { children: [_jsx("video", __assign({ muted: true, loop: true, autoPlay: true, playsInline: true }, { children: _jsx("source", { type: "video/mp4", src: VideoPomeloHat }, void 0) }), void 0), done || loading ? (_jsx("div", __assign({ className: "redeemed" }, { children: done ? (_jsx(_Fragment, { children: _jsx("img", { className: "img", src: CheckFill, alt: "Green Check" }, void 0) }, void 0)) : (_jsxs(_Fragment, { children: [_jsx(ActiveSpinner, { size: "2rem" }, void 0), _jsx("span", __assign({ className: "hint" }, { children: "\u767B\u8A18\u4E2D" }), void 0)] }, void 0)) }), void 0)) : null] }), void 0) }), void 0)] }), void 0) }, void 0), _jsx("div", { children: _jsxs("section", __assign({ className: "info" }, { children: [_jsx("div", __assign({ className: "right-bg" }, { children: _jsx("img", { src: PolygonDown, alt: "Right Bg" }, void 0) }), void 0), !done ? null : _jsx("h3", __assign({ className: "title-center" }, { children: "\u767B\u8A18\u6210\u529F" }), void 0), _jsx("div", __assign({ className: "description" }, { children: !done ? (_jsxs(_Fragment, { children: [_jsx("p", { children: "\u4ECA\u5E74\u4E2D\u79CB\u7BC0\u6216\u8A31\u4F60\u5DF2\u7D93\u5403\u904E\u6708\u9905\u4E86\uFF0C\u4F46\u4F60\u9084\u8A18\u5F97\u4E0A\u6B21\u6234\u67DA\u5B50\u5E3D\u662F\u5728\u5E7E\u5E74\u524D\u55CE\uFF1F" }, void 0), _jsx("p", { children: "\u300C\u67DA\u300D\u548C\u4FDD\u4F51\u7684\u300C\u4F51\u300D\u8B80\u97F3\u76F8\u540C\uFF0C\u67DA\u5B50\u7684\u76DB\u7522\u671F\u53C8\u6070\u5DE7\u843D\u5728\u4E2D\u79CB\u7BC0\u524D\u5F8C\u3002\u56E0\u6B64\u4EBA\u5011\u5728\u8CDE\u6708\u3001\u70E4\u8089\u3001\u5403\u6708\u9905\u4E4B\u9918\u9084\u6703\u525D\u67DA\u5B50\u7576\u6210\u98EF\u5F8C\u6C34\u679C\uFF0C\u4E5F\u85C9\u8AE7\u97F3\u5728\u4EBA\u5011\u5718\u5713\u7684\u6642\u523B\u7948\u6C42\u80FD\u4FDD\u4F51\u5168\u5BB6\u4EBA\u3002\u67DA\u5B50\u7684\u8B80\u97F3\u4E5F\u548C\u300C\u904A\u5B50\u300D\u76F8\u4F3C\uFF0C\u56E0\u6B64\u5C31\u6210\u70BA\u4EBA\u5011\u5728\u4E2D\u79CB\u7BC0\u5718\u5713\u7684\u8C61\u5FB5\u7269\u3002" }, void 0), _jsx("p", { children: "\u4F46\u591A\u6578\u4EBA\u9577\u5927\u4E4B\u5F8C\uFF0C\u5C31\u5F88\u5C11\u6234\u904E\u67DA\u5B50\u5E3D\u62CD\u7167\u3002\u4ECA\u5E74\u4E2D\u79CB\u7BC0\uFF0C\u5340\u584A\u52E2\u5728\u5143\u5B87\u5B99\u88E1\u6E96\u5099\u4E86 2022 \u9802\u67DA\u5B50\u5E3D NFT \u8981\u9001\u7D66\u5927\u5BB6\u3002\u7121\u8AD6\u4F60\u662F\u4ECA\u5E74\u4E0D\u65B9\u4FBF\u56DE\u5BB6\u3001\u4E0D\u559C\u6B61\u5403\u67DA\u5B50\u6216\u662F\u89BA\u5F97\u6234\u4E0A\u67DA\u5B50\u5E3D\u592A\u50CF\u5C0F\u5B69\uFF0C\u9019\u9802\u67DA\u5B50\u5E3D NFT \u4E0D\u50C5\u4E0D\u4F54\u7A7A\u9593\u3001\u4E0D\u7528\u5403\u67DA\u5B50\u800C\u4E14\u4E5F\u4E0D\u5FC5\u89AA\u81EA\u5E36\u4E0A\uFF0C\u5373\u4FBF\u624B\u908A\u6C92\u6709\u67DA\u5B50\u4F60\u4E5F\u53EF\u4EE5\u8DDF\u89AA\u670B\u597D\u53CB\u5728\u5143\u5B87\u5B99\u88E1\u4E00\u8D77\u5EA6\u904E\u4ECA\u5E74\u7684\u4E2D\u79CB\u7BC0\uFF01" }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx("p", { children: "\u767B\u8A18\u6210\u529F" }, void 0), _jsx("p", __assign({ className: "paragraph" }, { children: "\u67DA\u5B50\u5E3D NFT \u5C07\u6703\u65BC\u6578\u5929\u5F8C\u7A7A\u6295\u81F3\u60A8\u7684\u9322\u5305\u4E2D\uFF0C\u8ACB\u60A8\u8010\u5FC3\u7B49\u5019" }), void 0), _jsx("p", __assign({ className: "paragraph" }, { children: "\u60A8\u53EF\u4EE5\u5148\u4E0B\u8F09 Qubic iOS / Android App \u6216\u4F7F\u7528 Web \u7248\u67E5\u770B\u60A8\u7684 NFT" }), void 0)] }, void 0)) }), void 0), done && (_jsx("div", __assign({ className: "download" }, { children: _jsx(InlineDownloadButtons, { spacing: 8, maxHeight: 54 }, void 0) }), void 0)), _jsx("div", __assign({ className: "button-group" }, { children: !done ? (_jsxs(_Fragment, { children: [_jsx("button", __assign({ className: "button desktopSignIn", disabled: true }, { children: "\u9818\u53D6\u5DF2\u7D50\u675F" }), void 0), _jsx("button", __assign({ className: "button mobileSignIn", disabled: true }, { children: "\u9818\u53D6\u5DF2\u7D50\u675F" }), void 0), _jsx("a", __assign({ className: "button outline", href: "https://blog.maicoin.com/2022/05/10/qubic-faq/", target: "_blank", rel: "noreferrer" }, { children: "\u8A8D\u8B58\u865B\u64EC\u8CA8\u5E63\u9322\u5305" }), void 0)] }, void 0)) : null }), void 0), done ? null : (_jsx("div", { children: _jsx("span", { children: "* \u672A\u8A3B\u518A\u9322\u5305\u8005\uFF0C\u8ACB\u5148\u8A8D\u8B58\u865B\u64EC\u8CA8\u5E63\u9322\u5305\uFF01" }, void 0) }, void 0))] }), void 0) }, void 0)] }), void 0) }, void 0), _jsxs("footer", { children: [_jsxs("div", __assign({ className: "social" }, { children: [_jsx("a", __assign({ href: "https://www.facebook.com/QubicWallet/", target: "_blank", rel: "noreferrer" }, { children: _jsx("img", { src: FacebookFill, alt: "Facebook" }, void 0) }), void 0), _jsx("a", __assign({ href: "https://www.instagram.com/qubic_nft/", target: "_blank", rel: "noreferrer" }, { children: _jsx("img", { src: InstagramFill, alt: "Instagram" }, void 0) }), void 0)] }), void 0), _jsx("div", { children: "\u00A9 AMIS Technologies Co., Ltd." }, void 0)] }, void 0)] }), void 0), _jsx("dialog", __assign({ id: "loginDialog", ref: dialogRef }, { children: _jsxs("div", __assign({ className: "loginButtons" }, { children: [_jsxs("button", __assign({ className: "button loginButton", onClick: handleQubicLoginIn }, { children: [_jsx("span", __assign({ className: "buttonIcon" }, { children: _jsx("img", { src: QubicLogin, width: 48, height: 48, alt: "qubic-login-icon" }, void 0) }), void 0), "Qubic Wallet"] }), void 0), _jsxs("button", __assign({ className: "button loginButton", onClick: handleLoginMetaMask }, { children: [_jsx("span", __assign({ className: "buttonIcon" }, { children: _jsx("img", { src: MetamaskFox, width: 48, height: 48, alt: "metamask-login-icon" }, void 0) }), void 0), "MetaMask"] }), void 0)] }), void 0) }), void 0)] }, void 0));
};
export default React.memo(function () {
    var library = function (provider) {
        console.log({
            "provider.isQubic": provider.isQubic,
        });
        return new Web3(provider);
    };
    return (_jsx(Web3ReactProvider, __assign({ getLibrary: library }, { children: _jsx(App, {}, void 0) }), void 0));
});
